export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE = 1;
